export const openWindow = (link: string) => {
  const windowWidth  = 600;
  const windowHeight = 450;
  const x = window.screen.width / 2  - windowWidth / 2;
  const y = window.screen.height / 2 - windowHeight / 2;

  window.open(link, 'windowAuth', `width=${windowWidth}, height=${windowHeight}, location=no, toolbar=no, left=${x}, top=${y}`);
};